"use client";

import type { IBrandQuoteThemeConfig } from "@/@sdk/brands/brand-model";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function AdvancedThemeOptions({
  value,
  onChange,
}: {
  value: IBrandQuoteThemeConfig;
  onChange: (patch: Partial<IBrandQuoteThemeConfig>) => void;
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <div className="space-y-2">
        <Label>Navigation bar</Label>
        <Select
          value={value.navBarTemplate ?? "TYPE_2"}
          onValueChange={(navBarTemplate: "TYPE_1" | "TYPE_2") =>
            onChange({ navBarTemplate })
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="TYPE_1">Logo + share actions</SelectItem>
            <SelectItem value="TYPE_2">Centered logo</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Badge style</Label>
        <Select
          value={value.primaryColorFillMode ?? "Fill"}
          onValueChange={(primaryColorFillMode: "Outline" | "Fill") =>
            onChange({ primaryColorFillMode })
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Fill">Filled badges</SelectItem>
            <SelectItem value="Outline">Outline badges</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Hero layout</Label>
        <Select
          value={value.headerTemplate ?? "Default"}
          onValueChange={(headerTemplate: "Wide" | "Default") =>
            onChange({ headerTemplate })
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="Default">Default hero</SelectItem>
            <SelectItem value="Wide">Wide hero</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
